import React from "react";
import { Chart as ChartJS, registerables } from "chart.js";
import { MatrixController, MatrixElement } from "chartjs-chart-matrix";
import { Chart } from "react-chartjs-2";

ChartJS.register(...registerables, MatrixController, MatrixElement);

function RedirectedPeakActivityGraph({ data }) {
  if (!Array.isArray(data) || data.length === 0) {
    return <div></div>;
  }

  const weekDays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const hours = Array.from({ length: 24 }, (_, i) => i);

  // Initialize activity matrix
  const activity = {};
  weekDays.forEach((day) => {
    activity[day] = Array(24).fill(0);
  });

  // Fill matrix ONLY for redirection === 1
  data.forEach((company) => {
    company.data.forEach((entry) => {
    if (Number(entry.redirection) !== 1) return;

    const day = entry.day;
    const hour = parseInt(entry.hour.split(":")[0], 10);

    if (!weekDays.includes(day) || isNaN(hour)) return;

    activity[day][hour]++;
  });
  });

  // Flatten for chart.js matrix
  const matrixData = [];
  weekDays.forEach((day) => {
    hours.forEach((hour) => {
      matrixData.push({
        x: day,
        y: hour,
        v: activity[day][hour],
      });
    });
  });

  // Compute color scale
  const allValues = matrixData.map((d) => d.v);
  const maxValue = Math.max(...allValues);
  const minValue = Math.min(...allValues);

    const getColor = (v) => {
        if (v === 0) return "rgba(164, 201, 243, 0.4)"; // pale blue for no activity
        const intensity = (v - minValue) / (maxValue - minValue || 1);
        const alpha = 0.3 + intensity * 0.7;
        return `rgba(0, 123, 255, ${alpha})`;
  };

  const chartData = {
    datasets: [
      {
        label: "Redirected Calls",
        data: matrixData,
        backgroundColor: (ctx) => getColor(ctx.raw.v),
        borderColor: "rgba(255,255,255,0.9)",
        borderWidth: 1,
        width: (ctx) => {
          const chart = ctx.chart;
          if (!chart.chartArea) return 20;
          return chart.chartArea.width / weekDays.length;
        },
        height: (ctx) => {
          const chart = ctx.chart;
          if (!chart.chartArea) return 20;
          return chart.chartArea.height / 24;
        },
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: "Call Transfer Activity",
        font: { size: 18 },
      },
      tooltip: {
        callbacks: {
          title: (ctx) => {
            const { x, y } = ctx[0].raw;
            return `${x} at ${y}:00`;
          },
          label: (ctx) => `Redirected calls: ${ctx.raw.v}`,
        },
      },
    },
    scales: {
      x: {
        type: "category",
        labels: weekDays,
        offset: true,
        title: {
          display: true,
          text: "Weekday",
          font: { weight: "bold" },
        },
        grid: { display: false },
      },
      y: {
        type: "linear",
        min: 0,
        max: 23,
        reverse: true,
        ticks: {
          stepSize: 2,
          callback: (v) => `${v}:00`,
        },
        title: {
          display: true,
          text: "Hour of Day",
          font: { weight: "bold" },
        },
        grid: { display: false },
      },
    },
  };

  return (
    <div style={{ width: "90%", height: "500px", margin: "2rem auto" }}>
      <Chart type="matrix" data={chartData} options={options} />
    </div>
  );
}

export default RedirectedPeakActivityGraph;
